import React from 'react';
import { Progress, Space, Row, Col, Statistic } from 'antd';

const PrintStats = ({
  sessionStartTime,
  printSpeed,
  formatDuration,
  getSpeedInfo,
  sessionHistory
}) => {
  return (
    <>
      <div style={{ 
        backgroundColor: '#f5f5f5', 
        padding: '8px', 
        borderRadius: '4px',
        marginTop: '8px'
      }}>
        <div style={{ marginBottom: '4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <Space>
              {sessionStartTime ? (
                <>
                  <span>处理速度: {printSpeed.toFixed(1)} 单/分钟，</span>
                  <span style={{ color: getSpeedInfo(printSpeed).color }}>
                    {getSpeedInfo(printSpeed).message}
                    <span className={`speed-emoji ${
                      printSpeed >= 7 ? 'shake' : 
                      printSpeed >= 3 ? 'bounce' : 
                      'float'
                    }`}>
                      {printSpeed >= 7 ? '🚀' : 
                       printSpeed >= 3 ? '😃' : 
                       '☕️'}
                    </span>
                  </span>
                </>
              ) : (
                <span>扫描打印</span>
              )}
            </Space>
          </div>
          <span>会话时长: {formatDuration()}</span>
        </div>
        <Progress 
          percent={Math.min((printSpeed / 7) * 100, 100)} 
          strokeColor={getSpeedInfo(printSpeed).color}
          showInfo={false}
          size="small"
        />
      </div>

      <Row gutter={16} style={{ marginBottom: '16px', marginTop: '16px' }}>
        <Col span={8}>
          <Statistic
            title="已扫描"
            value={sessionHistory.filter(item => item.type === 'success').length}
            suffix="单"
            valueStyle={{ color: '#1890ff' }}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="已打印"
            value={sessionHistory.filter(item => item.type === 'success' && item.printed).length}
            suffix="单"
            valueStyle={{ color: '#52c41a' }}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="未找到"
            value={sessionHistory.filter(item => item.type === 'error').length}
            suffix="单"
            valueStyle={{ color: '#ff4d4f' }}
          />
        </Col>
      </Row>
    </>
  );
};

export default PrintStats;
